export default __webpack_public_path__ + "static/media/p3.c3a1441c.png";